const generateAdminContentSettingsFormData = ({
  contentId,
  visibilityMarkers,
  contentSettingsGroups = [],
}) => {
  const preSelectedGroupsMap = {};
  const groupList = [];
  for (const group of contentSettingsGroups) {
    const { id: groupId } = group;
    const isFlagged = visibilityMarkers?.some(
      (marker) => marker.group_id === groupId,
    );
    groupList.push({ group_id: groupId, is_flagged: isFlagged });
  }

  preSelectedGroupsMap[contentId] = groupList;

  return preSelectedGroupsMap;
};

export default generateAdminContentSettingsFormData;
